import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d1rzqm9rrs: FaireBrandEntity = {
  token: "b_d1rzqm9rrs",
  type: "brand",
  name: "Miller's Gourmet Foods, LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/dd91ab2290d9f9c91b591d5c7eac673cbfd421b15ab047cadc5915bfc4f9e6fc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d6888c6f9252f270ba2a6411ad1a037d593833e94508b2a717a22996cef1b3be.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dd91ab2290d9f9c91b591d5c7eac673cbfd421b15ab047cadc5915bfc4f9e6fc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d6888c6f9252f270ba2a6411ad1a037d593833e94508b2a717a22996cef1b3be.jpeg",
  location: "Valencia, PA, USA",
  minimumOrderDollars: 72,
  rating: 5,
  reviewCount: 24,
  isInsider: true,
  description:
    "Miller’s began as a humble experiment – cooking up a few jars in our home kitchen at the request of friends – then selling through local specialty stores.  The response was overwhelming, with smiles and empty jars all around.  Over 18 years later, our unique, award-winning banana pepper sauce is still crafted with the same care and attention to detail.\n\nUnlike most pepper sauces, we only use vine-ripened peppers picked at the peak of freshness.  All grown up, the mature banana and habanero peppers are processed from scratch and mixed with our special blend of mustard seeds and spices to create a sweet and spicy sauce with superior flavor.\n\nIT’S NOT THE EASY WAY…..IT’S JUST THE RIGHT WAY.  \n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:32.058Z",
    importedBy: "entity-db-cli",
  },
};
